<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="start"><span><a id="epigraph"><i>With knowledge doubt increases.</i></a></span></p><a id="epigraph">
<p class="center"><span>—GOETHE</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-start.vue?05b021f2